import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-note-sujet-item',
  templateUrl: './note-sujet-item.component.html',
  styleUrls: ['./note-sujet-item.component.scss']
})
export class NoteSujetItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
